import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Board from './components/Board';
import Contact from './components/Contact';
import Donation from './components/Donation';
import Speakers from './components/Speakers';
import Footer from './components/Footer';

import Login from './Signup/Login';
import Dashboard from './Signup/Dashboard';
import ProtectedRoute from './Signup/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public homepage */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Home />
              <About />
              <Board />
              <Donation />
              <Speakers />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* Login route */}
        <Route path="/login" element={<Login />} />

        {/* Protected dashboard route */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
